export default "__VITE_ASSET__2265ba80__"